import { Container, Stack, Box, Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router';
import { getMenu } from 'utils/getMenu';

interface IProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export function Page({ children, actions = null }: IProps) {
  const location = useLocation();

  return (
    <Box>
      <Container style={{ width: '100%' }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
          mt={4}
        >
          <Typography variant='h4' gutterBottom>
            {getMenu(location.pathname)}
          </Typography>
          {actions && actions}
        </Stack>

        {children}
      </Container>
    </Box>
  );
}
